import { AuthenticationScheme } from '../entities/credential.interface';

import { IntegrationConnectInput, SidebarInputType } from './action';

export const authSchemaRequiredInputs: Record<AuthenticationScheme, IntegrationConnectInput[]> = {
  [AuthenticationScheme.BASIC]: [],
  [AuthenticationScheme.IMPERSONATED_APP]: [],
  [AuthenticationScheme.OAUTH]: [],
  [AuthenticationScheme.OAUTH_APP]: [],
  [AuthenticationScheme.SERVICE_ACCOUNT]: [],
  [AuthenticationScheme.OAUTH_CLIENT_CREDENTIAL]: [
    {
      id: 'clientId',
      title: 'Client ID',
      type: SidebarInputType.ValueText,
      required: true,
    },
    {
      id: 'clientSecret',
      title: 'Client Secret',
      type: SidebarInputType.ValueText,
      required: true,
    },
  ],
};